export default __webpack_public_path__ + "static/media/player-lauren-colour-mob.6cbb1e0f.png";